import { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { LOGIN_PAGE_BASE_PATH } from './constants'

export const useNavigateLogin = () => {
    const router = useRouter()

    const navigateLogin = useCallback(
        (addSearchParams = false, redirectUrl?: string) => {
            let url = `${LOGIN_PAGE_BASE_PATH}?redirectUrl=`
            url += redirectUrl || `${window.location.pathname}${addSearchParams ? window.location.search : ''}`

            router.push(url)
        },
        [router]
    )

    return navigateLogin
}
